import type { Player } from '@/lib/types';
import { cn } from '@/lib/cn';
import { PlayerAvatar } from '@/features/player-photos/PlayerAvatar';

/** The same player identity for attention conversations and player follow-up. */
export function BoardPlayerIdentity({ player, fallbackName, nameAs: Name = 'h4', className }: {
  player?: Player;
  fallbackName: string;
  nameAs?: 'h4' | 'strong';
  className?: string;
}) {
  const jersey = player?.jersey_number?.trim();
  const position = player?.position?.trim();
  return <div className={cn('board-card-identity flex min-w-0 items-center gap-3', className)}>
    {player && <PlayerAvatar player={player} size="lg" />}
    <div className="min-w-0 break-words">
      <Name className="font-display text-ink">{player?.display_name.trim() || fallbackName}</Name>
      {jersey && <span className="sr-only">Jersey {jersey}.</span>}
      {position && <span className="block text-sm text-ink-muted">{position}</span>}
    </div>
  </div>;
}
